import { Injectable, Renderer2, RendererFactory2, inject } from '@angular/core';
import { appInsights } from '@ao/app/app.config';

@Injectable({
  providedIn: 'root',
})
export class GlobalEventTrackingService {
  private renderer: Renderer2;

  constructor() {
    const rendererFactory = inject(RendererFactory2);

    this.renderer = rendererFactory.createRenderer(null, null);
  }

  initializeGlobalEventTracking(): void {
    // Track all click events
    this.renderer.listen('document', 'click', (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      const elementName = target.tagName.toLowerCase();
      const elementId = target.id || 'no-id';
      const elementClass = target.className || 'no-class';

      appInsights.trackEvent({
        name: 'UserClick',
        properties: {
          elementName,
          elementId,
          elementClass,
          timestamp: new Date().toISOString(),
        },
      });
    });
  }
}
